import { useI18n } from '@/lib/i18n';

export function SplashScreen({ label = 'Загрузка…' }: { label?: string }) {
  const { t } = useI18n();
  return (
    <main className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-heritage-50 px-6">
      <img
        src="/icons/icon-192-v2.png"
        alt=""
        aria-hidden="true"
        className="h-20 w-20"
      />
      <p className="text-sm text-heritage-600">{t(label)}</p>
    </main>
  );
}
